import { Reducer } from 'redux';
import { InquiryState, InquiryActionTypes } from './type';
const initialState: InquiryState = {
  thirdDoctorDetail: {},
  list: {
    totalPage: 0,
    currentPage: 0,
    data: [],
  },
  datail: {},
  create: {
    attachmentList: [],
  },
  evaluate: {},
  evaluateTags: {},
  umpEvaluateTags: {},
  coupon: [], //问诊时的优惠券
  servpack: [], //问诊时的服务包
  patientsVas: {},
  currentPeople: {},
  productList: [],
  isReceivePrescriptionCard: false, // 是否获取处方卡
  tertiaryProfessionalList: [], // 三甲医生各专业信息
};

const reducer: Reducer<InquiryState> = (state = initialState, action) => {
  switch (action.type) {
  case InquiryActionTypes.FETCH_INQUIRY_NO_SUCCESS: {
    const { data } = action;
    return {
      ...state,
      create: {
        ...state.create,
        inquiryNo: data,
      },
    };
  }
  case InquiryActionTypes.FETCH_EVALUATE_TAGS_SUCCESS: {
    const { data } = action;
    return {
      ...state,
      evaluateTags: data,
    };
  }
  case InquiryActionTypes.FETCH_UMP_EVALUATE_TAGS_SUCCESS: {
    const { data } = action;
    return {
      ...state,
      umpEvaluateTags: data,
    };
  }
  case InquiryActionTypes.FETCH_INQUIRY_LIST_SUCCESS: {
    const { data, totalPage, currentPage } = action;
    if (currentPage === 1) {
      return {
        ...state,
        list: {
          data,
          totalPage,
          currentPage,
        },
      };
    }
    return {
      ...state,
      list: {
        data: [...state.list.data, ...data],
        totalPage,
        currentPage,
      },
    };
  }
  case InquiryActionTypes.FETCH_INQUIRY_DETAIL_SUCCESS: {
    const { data } = action;
    return {
      ...state,
      datail: data,
    };
  }
  case InquiryActionTypes.CLEAR_INQUIRY_DETAIL: {
    return {
      ...state,
      datail: {},
    };
  }
  // ump/mb 问诊详情，收到 IM消息推送通知问诊单已结束、问诊异常关闭等操作
  case InquiryActionTypes.UPDATE_INQUIRY_END_OR_OTHER_HANDLER: {
    let { datail = {} } = state;
    let { payload = {} } = action;
    return {
      ...state,
      datail: {
        ...datail,
        ...payload,
      },
    };
  }

  case InquiryActionTypes.RECEIVE_DOCTOR_PRESCRIPTION: {
    const { payload } = action;
    const { inquiryNo, status } = payload;
    return {
      ...state,
      [`${inquiryNo}_isReceivePrescriptionCard`]: status
    };
  }

  case InquiryActionTypes.FETCH_EVALUATE_BY_INQUIRY_SUCCESS: {
    const { data } = action;
    return {
      ...state,
      evaluate: data,
    };
  }
  case InquiryActionTypes.EDIT_INQUIRY: {
    const { key, value, payload = {} } = action;
    return {
      ...state,
      create: {
        ...state.create,
        [`${key}`]: value,
        ...payload,
      },
    };
  }
  case InquiryActionTypes.UPLOAD_FILE_SUCCESS: {
    const { data } = action;
    return {
      ...state,
      create: {
        ...state.create,
        attachmentList: [...state.create.attachmentList, data],
      },
    };
  }
  case InquiryActionTypes.DELETE_FILE: {
    return {
      ...state,
      create: {
        ...state.create,
        attachmentList: [
          ...state.create.attachmentList.filter((i) => {
            return i.id !== action.id;
          }),
        ],
      },
    };
  }
  case InquiryActionTypes.CLEAR_EVALUATE: {
    return {
      ...state,
      evaluate: {},
    };
  }
  case InquiryActionTypes.CLEAR_INQUIRY: {
    return {
      ...state,
      create: {
        attachmentList: [],
        ...(action.data || {}),
      },
      patientsVas: {},
    };
  }
  case InquiryActionTypes.SUBMIT_INQUIRY_SUCCESS: {
    return {
      ...state,
      create: {
        attachmentList: [],
        ...(action.data || {}),
      },
    };
  }
  case InquiryActionTypes.FETCH_INQUIRY_PRICE_SUCCESS: {
    const { data: { couponList = [], servpackList = [] } = {} } = action;
    //问诊用的优惠券
    const coupon: any[] = [];

    couponList.length &&
        couponList.forEach((element) => {
          const item = {
            ...element.coupon,
            couponEffectiveTime: (element.couponEffectiveTime || '').replace(/-/g, '/'),
            couponExpiryTime: (element.couponExpiryTime || '').replace(/-/g, '/'),
            id: element.id,
            couponStatus: element.userCouponStatus,
          };
          coupon.push(item);
        });
    return {
      ...state,
      coupon: coupon,
      servpack: servpackList,
    };
  }
  case InquiryActionTypes.SET_INQUIRY_CURRENTPEOPLE: {
    let { payload = {} } = action;
    return {
      ...state,
      currentPeople: payload.isProgressInquiry
        ? {
          ...state.currentPeople,
          ...payload,
        }
        : payload,
    };
  }
  //医生详情
  case InquiryActionTypes.THIRD_DOCTOR_DETAIL_REDUCER: {
    return {
      ...state,
      thirdDoctorDetail: action.data,
    };
  }
  case InquiryActionTypes.PRODUCT_LIST_REDUCER: {
    const { data } = action;
    return {
      ...state,
      productList: data,
    };
  }
  case InquiryActionTypes.FETCH_THIRD_DOCTOR_PROFESSION: {
    return {
      ...state,
      tertiaryProfessionalList: action.data,
    };
  }
  default: {
    return state;
  }
  }
};

export { reducer as InquiryReducer };
